import React, { useEffect, useContext } from 'react';
import Layout from '../../components/Layout/Layout';
import { AnalyticsContext } from '../../ModularReduxAnalytics';

import css from './VerifyDeclined.module.scss';
import Button from '../../components/UI/Button';
import { useAppDispatchers } from '../../state/app';
import { useUser, useUserDispatchers } from '../../state/user';
import { useToggles } from '../../state/toggles';

const VerifyHardDeclined = () => {
  const { analytics } = useContext(AnalyticsContext);
  const { setIsKycRetryAttempt, clearError } = useAppDispatchers();
  const { setNextRegStep } = useUserDispatchers();
  const { hasExceededMaxVerificationAttempts } = useUser();
  const { kycRetryEnabled } = useToggles();

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Identity Verification Hard Failed');
  }, []);

  const onKycRetry = () => {
    clearError();
    setIsKycRetryAttempt({ isKycRetryAttempt: true });
    setNextRegStep('register');
  };

  const shouldShowKycRetryButton =
    !hasExceededMaxVerificationAttempts && kycRetryEnabled.enabled;

  return (
    <Layout>
      <>
        <div className={css.verifyDeclined}>
          <h1 data-e2e="verify-declined-header">
            We were unable to verify your identity
          </h1>
          <h2 data-e2e="message" data-testid="verify-text">
            To comply with federal laws on anti-terrorism and anti-money
            laundering activities, Greenlight is required to obtain and verify
            the information of every person who opens an account with us. This
            information includes your name, address, date of birth, and other
            details that enable us to identify you.
          </h2>
          <h2>
            Based on the information you provided, we're unable to open an
            account for you.
          </h2>
          {shouldShowKycRetryButton && (
            <Button
              outline={true}
              onClick={onKycRetry}
              text="Resubmit my information"
              data-testid="kyc-retry-button"
            />
          )}
        </div>
      </>
    </Layout>
  );
};

export default VerifyHardDeclined;
